import {Link} from "react-router";
import {Burger, Button, Container, Drawer, Group, Image, Stack} from "@mantine/core";
import {useDisclosure} from "@mantine/hooks";

export function AppNav() {
  const [isNavOpen, {toggle: toggleNav, close: closeNav}] = useDisclosure(false);

  return (
    <Container size="lg" h="100%">
      <Drawer opened={isNavOpen} onClose={closeNav} title="Menu" position="right" padding="md" size="xs">
        <Stack gap="sm">
          {/* <Button component={Link} to="/fr/regles" variant="subtle" color="dark" onClick={closeNav}>
            Règles
          </Button> */}
          <Button
            component="a"
            href="https://www.discord.gg/fS3ZYUaESR"
            target="_blank"
            rel="noreferrer noopener"
            variant="subtle"
            color="dark"
            onClick={closeNav}
          >
            Discord
          </Button>
          <Button
            component="a"
            target="_blank"
            rel="noreferrer noopener"
            href="https://fr.ulule.com/hexploit/"
            onClick={closeNav}
          >
            Acheter le jeu
          </Button>
        </Stack>
      </Drawer>

      <Group justify="space-between" align="center" h="100%">
        <Link to="/" aria-label="Accueil Hexploit">
          <Image
            src="https://static.digisthesia.com/hexploit/images/logo_hexploit_250.webp"
            alt="Logo Hexploit"
            w={120}
            h={70}
          />
        </Link>

        <Group gap="md" visibleFrom="sm">
          {/* <Button component={Link} to="/fr/regles" variant="subtle" color="dark">
            Règles
          </Button> */}
          <Button
            component="a"
            href="https://www.discord.gg/fS3ZYUaESR"
            target="_blank"
            rel="noreferrer noopener"
            variant="subtle"
            color="dark"
          >
            Discord
          </Button>
          <Button component="a" href="https://fr.ulule.com/hexploit/" target="_blank" rel="noreferrer noopener">
            Acheter le jeu
          </Button>
        </Group>
        <Burger opened={isNavOpen} onClick={toggleNav} hiddenFrom="sm" aria-label="Ouvrir le menu de navigation" />
      </Group>
    </Container>
  );
}
